<template>
  <div v-if="!props.disabled">
    <a v-if="isExternalLink(props.to)" :href="to as string" :disabled="props.disabled" :target="props.target">
      <slot :is-disabled="props.disabled" />
    </a>
    <RouterLink v-else :to="props.to" class="h-full" :disabled="props.disabled">
      <slot :is-disabled="props.disabled" />
    </RouterLink>
  </div>
  <div v-else class="cursor-not-allowed" :disabled="props.disabled">
    <slot :is-disabled="props.disabled === true" />
  </div>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from "vue-router";
import { isExternalLink } from "../util/isExternalLink";

const props = defineProps<{
  to: RouteLocationRaw | string;
  disabled?: boolean;
  target?: string;
}>();
</script>
